import { jsx as _jsx } from "react/jsx-runtime";
import { isNil } from 'ramda';
import { createContext, useCallback, useContext, useMemo } from 'react';
import { useColumnWidthsLocalStorageState } from '../localStorage/useLocalStorageKeys';
import { useSTContext } from './SmartTableContext';
const context = createContext(null);
const Provider = context.Provider;
export const UserColumnWidthsProvider = ({ children }) => {
    const table = useSTContext();
    const tableKey = table.tableKey;
    const [userWidths, setUserWidths] = useColumnWidthsLocalStorageState(tableKey, {});
    const setUserWidth = useCallback((fieldName, width) => setUserWidths((prev) => ({
        ...prev,
        [fieldName]: width,
    })), [setUserWidths]);
    const value = useMemo(() => ({ userWidths, setUserWidth }), [userWidths, setUserWidth]);
    return _jsx(Provider, { value: value, children: children });
};
const useUserColumnWidthsContext = (hookName) => {
    const contextValue = useContext(context);
    if (isNil(contextValue)) {
        throw new Error(`${hookName} must be used within UserColumnWidthsProvider`);
    }
    return contextValue;
};
export const useUserColumnWidth = (fieldName) => {
    const { userWidths } = useUserColumnWidthsContext('useUserColumnWidth');
    return userWidths[fieldName];
};
export const useSetUserColumnWidth = (fieldName) => {
    const { setUserWidth } = useUserColumnWidthsContext('useSetUserColumnWidth');
    return useCallback((width) => setUserWidth(fieldName, width), [fieldName, setUserWidth]);
};
//# sourceMappingURL=UserColumnWidthsContext.js.map